import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation } from 'react-query';

function useUploadCSV({ headers = {} }) {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  function upload(data) {
    return privateFetch
      .post(`/v1/admin/user/csv/upload`, data, { headers })
      .then((res) => res.data);
  }

  return useMutation(upload, {
    onSuccess() {},
    onError() {},
    onSettled() {},
  });
}

export default useUploadCSV;
